jQuery(document).ready(function($) {

    $(".accordion-wrapper").each(function() {
        var firstAccordion = $(this).find('.accordion').first();
        $(firstAccordion).find('.accordion-plus-minus').addClass('clicked');
        $(firstAccordion).siblings().addClass('bg-black');
        var content = $(firstAccordion).find('.accordion-content');
        $(content).slideDown();
        $(firstAccordion).siblings().addClass('open');
        var siblingContent = $(firstAccordion).siblings().find('.accordion-content');
        siblingContent.slideUp();
        var firstPlusMinus = $(firstAccordion).find('.accordion-plus-minus');
        $(firstPlusMinus).addClass('clicked');
        $('.accordion-plus-minus').parent().parent().addClass('open');
		    $('.accordion-plus-minus.clicked').parent().parent().removeClass('open');
    });

      /* accordion functionality */

      $(".content-accordion-header").click(function() {
        $(this).addClass('open');
        $(this).parent().parent().parent().removeClass('bg-black');
        var content = $(this).siblings();
        var plusMinus = $(this).parent().find('.accordion-plus-minus');
        var siblingPlusMinus = $(this).parent().parent().parent().siblings().find('.accordion-plus-minus');
        var siblingHeader = $(this).parent().parent().parent().siblings().find('.content-accordion-header');
        var siblingContent = $(this).parent().parent().parent().siblings().find('.accordion-content');
        var siblingAccordion = $(this).parent().parent().parent().siblings();
        $(plusMinus).addClass("clicked"); 
        $(siblingPlusMinus).removeClass('clicked');
        $(siblingAccordion).addClass('bg-black');
        $(siblingHeader).removeClass('open');
        $(siblingContent).slideUp();
        $(content).slideDown();
        $('.accordion-plus-minus').parent().parent().parent().addClass('open');
        $('.accordion-plus-minus.clicked').parent().parent().parent().removeClass('open');

        
        // $(this).addClass('open');
        // $(this).parent().parent().parent().removeClass('bg-black');
        // var content = $(this).siblings();
        // var plusMinus = $(this).parent().find('.accordion-plus-minus');
        // var siblingPlusMinus = $(this).parent().siblings().find('.accordion-plus-minus');
        // var siblingAccordion = $(this).parent().parent().parent().siblings();
        // var siblingContent = $(this).parent().parent().parent().siblings().find('.accordion-content');
        // $(siblingPlusMinus).removeClass('clicked');
        // $(siblingContent).slideUp();
        // $(siblingAccordion).addClass('bg-black');
        // $(siblingContent).siblings().removeClass('open');
        // $(plusMinus).toggleClass("clicked"); 
        // $(content).slideDown();
    });

});
    
  